import React, { useState, useRef, useEffect } from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ReactPlayer from "react-player";
import Modal from "react-modal";
import * as S from "./styles";
import { FaPlay, FaPause } from "react-icons/fa";
import thumbVideo1 from "@/assets/thumbs/modulo1/1.png";
import thumbVideo2 from "@/assets/thumbs/modulo1/2.png";
import thumbVideo3 from "@/assets/thumbs/modulo1/3.png";
import "swiper/swiper-bundle.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Configuração do Modal para acessibilidade
Modal.setAppElement("#root");

const videos = [
  {
    url: "https://www.youtube.com/embed/VKPLUQIWmpQ?si=6150TQBuoCwymXAo",
    thumb: thumbVideo1,
    title: "Título do Vídeo 1",
    description: "Descrição do Vídeo 1",
    rating: 4,
  },
  {
    url: "https://www.youtube.com/embed/yroyP8N3Ok0?si=bVBllFEtKT0D4a-h",
    thumb: thumbVideo2,
    title: "Título do Vídeo 2",
    description: "Descrição do Vídeo 2",
    rating: 4,
  },
  {
    url: "https://www.youtube.com/embed/B0B7sj2OLNI?si=zxkNlvTTWNLmWLWW",
    thumb: thumbVideo3,
    title: "Título do Vídeo 3",
    description: "Descrição do Vídeo 3",
    rating: 4,
  }
];

const Courses: React.FC = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const playerRef = useRef<ReactPlayer>(null);

  useEffect(() => {
    // Configuração do Modal para acessibilidade
    Modal.setAppElement("#root");
  }, []);

  const openModal = (url: string) => {
    setCurrentVideo(url);
    setIsPlaying(true);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setIsPlaying(false);
    setModalIsOpen(false);
    setCurrentVideo("");
  };

  const handleProgress = (state: { played: number; seeking: boolean }) => {
    if (!state.seeking) {
      setProgress(state.played);
    }
  };

  const handleSeekChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const currentTime =
      parseFloat(e.target.value) * playerRef.current!.getDuration();
    console.log("Minuto clicado:", currentTime / 60);
    setProgress(parseFloat(e.target.value));
    playerRef.current!.seekTo(parseFloat(e.target.value));
  };

  return (
    <>
      <S.ModuleContainer>
        <S.RowContainer>
          <S.CustomSwiperPagination>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              centeredSlides={true}
              spaceBetween={3}
              autoplay={{ delay: 3000 }}
              pagination={{
                el: ".swiper-pagination",
                clickable: true,
              }}
              navigation={{
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
              }}
              breakpoints={{
                768: {
                  slidesPerView: 3,
                },
                992: {
                  slidesPerView: 3,
                },
                1200: {
                  slidesPerView: 3,
                },
              }}
            >
              {videos.map((video, index) => (
                <SwiperSlide key={index}>
                  <S.CardContainer onClick={() => openModal(video.url)}>
                    <S.Thumb src={video.thumb} alt={video.title} />
                    <S.ContentOverlay>
                      {/* <S.Title>{video.title}</S.Title>
                      <S.Description>{video.description}</S.Description> */}
                    </S.ContentOverlay>
                  </S.CardContainer>
                </SwiperSlide>
              ))}
              <div className="swiper-pagination"></div>
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
            </Swiper>
          </S.CustomSwiperPagination>
        </S.RowContainer>
      </S.ModuleContainer>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Video Modal"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            background: '#1A1D23',
            padding: '20px',
            border: 'none',
            zIndex: 1000,
            width: '80%',
            height: '80%',
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            zIndex: 999,
          },
        }}
      >
        <S.ModalContent>
          <S.ModalClose onClick={closeModal}>×</S.ModalClose>
          {currentVideo && (
            <>
              <S.Video
                src={currentVideo}
              />
            </>
          )}
        </S.ModalContent>
      </Modal>
    </>
  );
};

export default Courses;
